export const LOAD_GROUP_DATA = 'LOAD_GROUP_DATA';
export const LOAD_VIDEO_DATA = 'LOAD_VIDEO_DATA';
export const SET_SESSION = 'SET_SESSION';
export const LOAD_FILE_DATA = 'LOAD_FILE_DATA';